import { render } from "./post-smtp-header.vue?vue&type=template&id=77ec4cc7&scoped=true"
import script from "./post-smtp-header.vue?vue&type=script&lang=js"
export * from "./post-smtp-header.vue?vue&type=script&lang=js"

import "./post-smtp-header.vue?vue&type=style&index=0&id=77ec4cc7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ec4cc7"],['__file',"src/components/post-smtp-header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77ec4cc7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77ec4cc7', __exports__)) {
    api.reload('77ec4cc7', __exports__)
  }
  
  module.hot.accept("./post-smtp-header.vue?vue&type=template&id=77ec4cc7&scoped=true", () => {
    api.rerender('77ec4cc7', render)
  })

}


export default __exports__